import {createSelector, MemoizedSelector} from '@ngrx/store';
import {CustomCategoryState, StateWithCategory} from '../custom-category-state';
import {Category} from '@spartacus/core';
import {getCategoryState} from './feature-selector';

export const getAllCategoryState: MemoizedSelector<
  StateWithCategory,
  Category
> = createSelector(
  getCategoryState,
  (state: CustomCategoryState) => state?.category
);


